<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户付费</span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <el-button v-permisaction="['config:userRemain:export']" icon="el-icon-download" size="mini" @click="exportData(8)">导出</el-button>
          </el-form-item>
        </el-form>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="日期"
          />
          <el-table-column
            prop="login_count"
            label="登录人数"
          />
          <el-table-column
            prop="pay_user_count"
            label="付费用户数"
          />
          <el-table-column
            prop="vip_price"
            label="Vip金额"
            :formatter="priceFormatter"
          />
          <el-table-column
            prop="order_price"
            label="订单金额"
            :formatter="priceFormatter"
          />
          <el-table-column
            prop="pay_price"
            label="付费总金额"
            :formatter="priceFormatter"
          />
          <el-table-column
            prop="avg_user_count"
            label="人均付费次数"
          />
          <el-table-column
            prop="pay_rate"
            label="付费率"
            :formatter="numFormatter"
          />
          <el-table-column
            prop="arppu"
            label="ARPPU"
            :formatter="priceFormatter"
          />
          <el-table-column
            prop="arpu"
            label="ARPU"
            :formatter="priceFormatter"
          />
          <el-table-column
            prop="total_order_count"
            label="总订单数"
          />
          <!--          <el-table-column-->
          <!--            prop="order_count"-->
          <!--            label="成功订单数"-->
          <!--          />-->
          <el-table-column
            prop="order_rate"
            label="订单成功率"
            :formatter="numFormatter"
          />
        </el-table>

        <el-table
          :data="tableData2"
          border
          style="width: 100%;margin-top: 20px"
        >
          <el-table-column
            prop="date"
            label="日期"
          />
          <el-table-column
            prop="reg_pay_user_count"
            label="注册付费人数"
          />
          <el-table-column
            prop="reg_pay_price"
            label="注册付费金额"
            :formatter="priceFormatter"
          />
          <el-table-column
            prop="reg_arppu"
            label="注册付费ARPPU"
            :formatter="priceFormatter"
          />
          <el-table-column
            prop="reg_pay_rate"
            label="注册付费率"
            :formatter="numFormatter"
          />
          <el-table-column
            prop="pay_user_count"
            label="老付费人数"
          />
          <el-table-column
            prop="pay_price"
            label="老付费金额"
            :formatter="priceFormatter"
          />
          <el-table-column
            prop="arppu"
            label="老付费ARPPU"
            :formatter="priceFormatter"
          />
          <el-table-column
            prop="pay_rate"
            label="老付费率"
            :formatter="numFormatter"
          />
          <el-table-column
            prop="first_pay_count"
            label="首次付费人数"
          />
          <el-table-column
            prop="first_pay_price"
            label="首次付费金额"
            :formatter="priceFormatter"
          />
        </el-table>

        <el-row :gutter="12">
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <EchartTemp ref="firstPayCount" title="首次付费人数" />
          </el-col>
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <EchartTemp ref="firstPayPrice" title="首次付费金额" />
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <EchartTemp ref="regPayArpu" title="注册付费ARPU" />
          </el-col>
          <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
            <EchartTemp ref="regPayRate" title="注册付费率" />
          </el-col>
        </el-row>

      </el-card>

      <IndexSubVip :export-show="true" />

      <PayLevelStat />

      <el-card>
        <IndexPayDate :export-show="true" />
      </el-card>

      <el-card>
        <RegPayDate :export-show="true" />
      </el-card>

      <!--      <el-card>-->
      <!--        <div slot="header" class="clearfix">-->
      <!--          <span>规则礼包统计</span>-->
      <!--        </div>-->
      <!--        <GiftStat />-->
      <!--      </el-card>-->
    </template>

  </BasicLayout>
</template>

<script>
import { exportPayStatData, exportStatData } from '@/api/statistics/user_remain'
import IndexPayDate from '@/components/Index/IndexPayData.vue'
import RegPayDate from '@/components/Index/RegPayRemain.vue'
import EchartTemp from '@/components/Charts/Charts.vue'
import PayLevelStat from '@/views/config/user-pay/components/pay_level.vue'
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'
import IndexSubVip from '@/components/Index/IndexSubVip.vue'

export default {
  name: 'UserPayStat',
  components: {
    IndexSubVip,
    IndexPayDate,
    RegPayDate,
    PayLevelStat,
    EchartTemp
  },
  data() {
    return {
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: ''
      },
      loading: false,
      options: [],
      tableData: [],
      tableData2: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  created() {
    this.getTables()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.getTables()
    },
    getTables() {
      exportPayStatData(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.pay
          this.tableData2 = res.data.regPay
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          this.$refs.firstPayCount.refresh(this.initChartData('注册付费人数', 'reg_pay_user_count'))
          this.$refs.firstPayPrice.refresh(this.initChartData('注册付费金额', 'reg_pay_price'))
          this.$refs.regPayArpu.refresh(this.initChartData('注册付费ARPPU', 'reg_arppu'))
          this.$refs.regPayRate.refresh(this.initChartData('注册付费率', 'reg_pay_rate'))
        } else {
          this.msgError(res.msg)
        }
      })
    },
    initChartData(title, key) {
      const obj = { legend: [], series: [], xAxis: [] }
      const seriesData = []
      for (const i in this.tableData2) {
        const val = this.tableData2[i]
        obj.xAxis.push(dateStrTodate(val.date))
        seriesData.push(val[key])
      }
      const temp = {
        name: title,
        data: seriesData,
        type: 'line',
        smooth: true,
        label: {
          show: true,
          position: 'top', // 标签显示在折线图顶部
          formatter: '{c}' // 显示数值
        }
      }
      obj.legend.push(title)
      obj.series.push(temp)
      return obj
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    priceFormatter(row, column, cellValue) {
      return '$' + cellValue
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '新增留存'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['次日', '3日', '7日', '15日', '30日']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '次日',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '3日',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '7日',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '15日',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '30日',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    exportData(typ) {
      exportStatData({ startDate: this.queryParams.startDate, endDate: this.queryParams.endDate, type: typ }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
